<template>

  <div class="row mb-2">
    <div class="col-3">

      <div
        class="ratio ratio-1x1"
      >

        <div
          class="d-flex justify-content-center align-items-center bg-secondary-subtle"
        >
          <span class="">
            <image-component
                :key="image.id"
                :image-id="image.id"
                :is_preview_only="true"
                thumb_class=""
            />
          </span>
        </div>
      </div>

      <!--
      <image-component
          :key="image.id"
          :image-id="image.id"
          :is_preview_only="true"
          thumb_class="none w-100"
      />
       -->
    </div>
    <div class="col-9 pt-4">

      <input
        v-model="image.title"
        @change="setInputChange()"
        type="text"
        class="form-control mb-2"
        :placeholder="$t('image.component.input.description.placeholder')"
      />
      <input
          v-model="image.copyright"
          @change="setInputChange()"
          type="text"
          class="form-control mb-2"
          :placeholder="$t('image.component.input.copyright.placeholder')"
      />

      <multiselect
          v-model="image.tags"
          :options="tags_option"
          :multiple="true"
          :taggable="true"
          label="language"
          track-by="id"
          :custom-label="formatSelectTag"

          :placeholder="$t('image.component.input.tags.placeholder')"
          :close-on-select="true"
          :clear-on-select="true"
          @search-change="asyncSearchTag"
          @open="asyncSearchTag"
          @tag="addTag"
          :tagPlaceholder="$t('image.component.input.tags.placeholder_tag')"
          class="form-control mb-1 p-0 border-0"
          @remove="setInputChange"
          @select="setInputChange"
      >
        <template v-slot:tag="{ option, remove  }">
          <span class="btn btn-sm btn-outline-secondary me-1 mb-1">
            <span>{{ option.title }}</span>
            <span class="remove-tag bi bi-x ms-1" @click="remove(option)"></span>
          </span>
        </template>
      </multiselect>

      <div
          v-if="image.tags.length > 0"
          class="text-start ms-2 text-secondary"
      >
        <span>
          <i class="bi bi-pen"></i>
          {{$t('image.component.input.tags.to_title')}}
        </span>
        <template v-for="(tag, index) in image.tags" >
          <a
            @click.prevent="addToTitle(tag.title)"
            href="#toTitle"
            class="ms-1 link-primary"
          >
            {{tag.title}}
          </a>
        </template>

      </div>



      <div
        v-if="image.is_saving"
        class="d-flex justify-content-end align-content-center"
      >
        <div class="d-flex align-items-center">
          <small class="text-secondary me-2">{{ $t('image.component.saving.title') }}</small>
          <div class="spinner-border spinner-border-sm text-secondary " aria-hidden="true"></div>
        </div>
      </div>


    </div>
  </div>
<!--
  <display-debug class="bg-white">
    <template #debugView>image  {{image}}</template>
  </display-debug>
  -->
</template>

<script>
import multiselect  from 'vue-multiselect'
import ImageComponent from "@/components/general/Image";
import axios from "axios";

let timer;
let timer_save
let gallery_images;
export default {
  name: "GalerieImageDetailComponent",
  props: {
    "modelValue": [String, Number],
    "detailId": [String, Number],
  },
  components: {
    ImageComponent,
    multiselect,
  },
  emits: [
    //'update:modelValue',

  ],
  created() {

  },
  mounted() {
    if(this.detailId) {
      this.loadImageDetail(this.detailId);
    }
  },

  data() {
    return {
      is_change: false,
      image: {
        id: null,
        title: null,
        copyright: null,
        tags: [],
        is_saving: null,
      },
      tags_option: []
    }
  },
  methods: {
    onTagSelect(tag) {
      console.log('Právě jsi vybral tag:', tag);
      //console.log('Název tagu:', selectedOption.name);

      // Zde můžeš provést specifickou akci jen pro tento jeden tag
    },
    addToTitle(tagTitle) {
      if(this.image.title) {
        if (!this.image.title.includes(tagTitle)) {
          this.image.title += ' ' + tagTitle;
        }
      }else{
        this.image.title =  tagTitle;
      }
    },

    setInputChange(tag) {
      let popularTags = localStorage.getItem(
          this.getApiConfig('tags.popularTagName')
      );
      if(
          !popularTags
      ) {
        popularTags = []
        //console.log('setInputChange popularTags: EMPTY', popularTags, );
      }else{
        popularTags = JSON.parse(popularTags);
        //console.log('setInputChange popularTags: LOAD', popularTags, );
      }

      if (!popularTags.includes(tag.id)) {
        popularTags.push(tag.id);
        //popularTags.unshift(tag.id);
        /**/
        localStorage.setItem(
            this.getApiConfig('tags.popularTagName'),
            JSON.stringify(popularTags)
        )

      }



      //console.log('setInputChange popularTags:', popularTags, );

      /*
      if (!popularTags.includes(tag.id)) {
        popularTags.push(tag.id);
        //popularTags.unshift(tag.id);
        localStorage.setItem(
            this.getApiConfig('tags.popularTagName'),
            JSON.stringify(popularTags)
        )
      }
    */
      //console.log('setInputChange Právě jsi vybral tag:', tag.id, );
      this.is_change = true;
    },
    async loadImageDetail(id) {

      axios.defaults.baseURL = this.getBaseRoot();
      //let apiPath = this.cfg.api.gallery.preview.path +"?" + this.cfg.api.gallery.preview.input.id + "=" + id;

      let apiPath = this.getApiConfig('image.detail.path') + id;
      // + this.getApiConfig('image.preview.input.id')

      //console.log('dev loadImageDetail', id, apiPath)
      axios({
        url: apiPath,
        //method: this.cfg.api.gallery.browse_service.method,
        method: this.getApiConfig('gallery.detail.method') ,
        withCredentials: true,
        headers: this.getRequestHeader(),
      }).then((res) => {
        //console.log('dev loadImageDetail RESx', id, res.data.response.data);
        this.image.id = id;
        this.image.title = res.data.response.data.title;
        this.image.copyright = res.data.response.data.copyright;
        this.image.tags = res.data.response.data.tags;

      })
      .catch((err) => {
        console.error('dev loadImageDetail RESx', err)

      })
    },

    async asyncSearchTag (query) {
      //console.log("dev asyncFind", query)

      if(timer) clearInterval(timer);
      timer = setTimeout(
          () => {
            axios.defaults.baseURL = this.getBaseRoot();
            let apiPath = this.getApiConfig('tags.select_list.path')

            if (query) apiPath += query
            let popularTags = localStorage.getItem(
                this.getApiConfig('tags.popularTagName')
            );
            if(
                popularTags
                && (!query || query == '')
            ) {
              apiPath += '&tags=' + popularTags
            }



            axios({
              url: apiPath,
              method: "get",
              withCredentials: true,
              headers: this.getRequestHeader(),
            }).then((res) => {
              this.tags_option = res.data.response.list.data;
            })
            .catch((err) => {
              this.tags_option = []
              //console.error("DEV tags catch", err);
            })
          },
          500
      )
    },

    formatSelectTag ({ id, title }) {
      return `${title}`
    },

    addTag (newTag) {
      let formData = new FormData;
      formData.append('tag_title', newTag)
      axios.defaults.baseURL = this.getBaseRoot();
      axios({

        url: this.getApiConfig('tags.create_simple.path'),
        data: formData,
        method: "post",
        withCredentials: true,
        headers: this.getRequestHeader(),
      }).then((res) => {
        if(res.data.status){
          const newTag = {
            'id': res.data.response.data.id,
            'title': res.data.response.data.nazev
          }
          this.image.tags.push(newTag);
          //TODO pridat popularni
        }else{
          alert("nepodarilo se pridat novy stitek")
        }
      })

      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      //this.options.push(tag)
      //this.selectModel.push(tag)
    },


  },
  computed: {

  },

  watch: {
    "image": {
      handler(newVal, oldVal) {

        if(typeof oldVal != "undefined" && this.is_change) {
          if(timer_save) clearInterval(timer_save);
          timer_save = setTimeout(
              () => {
                this.image.is_saving = true;

                let formData = new FormData();
                formData.append('image_id', this.image.id );
                if(this.image.title ) formData.append('image_title', this.image.title );
                if(this.image.copyright ) formData.append('image_copyright', this.image.copyright);
                formData.append('image_tags',  JSON.stringify(this.image.tags));

                axios.post( this.getBaseRoot() + this.getApiConfig('image.save_info.path'),
                    formData,
                    {
                      headers: this.getRequestHeaderUpload()
                    })
                    .then((res) => {
                      this.is_change = false;
                    })
                    .catch((err) => {
                      console.error('image save failure', err);
                    })
                    .finally(() =>{
                      this.image.is_saving = false;
                    })
              },
              700
          )
        }
      },
      deep: true,
      immediate: true
    },
  }
};
</script>
<style lang="scss">

</style>